import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'xemex-page-body',
  standalone: true,
  styleUrl: './page-body.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { '[class.scrollable]': 'scrollable()' },
  template: `<ng-content />`,
})
export class PageBodyComponent {
  scrollable = input<boolean>(false);
}
